<ng-container>
  <div *ngIf="cancellationPolicies?.from !== 'N/A'; else noData" class="timeline-container" [ngClass]="{'rentacar-layout': rentacarLayout}" style="border: 1px solid #000000; border-radius:
  12px;">
    <!-- Línea de tiempo horizontal -->
    <div class="timeline-wrapper">
      <div class="timeline-track">
        <div class="timeline-segment flex-column" *ngIf="isFreeCancellationActive()" [style.width.%]="getSegmentWidth(0)">
          <div class="d-flex flex-column align-items-center justify-content-start" style="width: 100%; height: 135px;">
            <img src="../../../../assets/icons/search-result/gratuita.svg" style="width: 26px" alt="" />
            <p class="usb-modal-text--subtitle semi-bold free-cancellation" style="
                  font-family: &quot;Poppins&quot;, sans-serif;
                  font-size: 14px;
                  font-weight: 500;
                  color: black;
                  margin-top: 15px;
                  margin-bottom: 0;
                  line-height: 1.5;
              ">Cancelación gratuita</p>
          </div>

          <div
            class="timeline-segment free-segment"
            style="height: 12px; border-bottom-left-radius: 6px; border-top-left-radius: 6px; width: 100%"
          ></div>

          <div class="d-flex justify-content-between pr-2" style="width: 100%">
            <div class="d-flex flex-column">
              <p
                class="mb-0 usb-rentacar-light-text"
                style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black; margin-top: 20px;
                text-align: left;"
              >
                Desde el
              </p>
              <p class="mb-0 usb-rentacar-light-text" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black">
                {{ firstDayOfPreviousMonth(cancellationPolicies.from) | date: "dd/MM/yyyy" }}
              </p>
            </div>
            <div class="d-flex flex-column">
              <p
                class="mb-0 usb-rentacar-light-text"
                style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black; margin-top: 20px;
                text-align: right;"
              >
                Hasta el
              </p>
              <p class="mb-0 usb-rentacar-light-text" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black">
                {{ adjustDate(cancellationPolicies.from, -1) | date: "dd/MM/yyyy" }}
              </p>
            </div>
          </div>

          <p style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 14px; font-weight: 500; color: #000000; margin-top: 35px">
            Reembolso total
          </p>
        </div>

        <ng-container *ngIf="getPartialPenaltyRange() as penaltyRange">
          <div
            class="timeline-segment flex-column"
            style="position: relative"
            [style.width.%]="getSegmentWidth(1)"
          >
            <div class="d-flex flex-column align-items-center justify-content-start" style="width: 100%; height: 135px;">
              <img src="../../../../assets/icons/search-result/parcial.svg" style="width: 26px" alt="" />
              <p
                class="d-flex flex-column"
                style="
                  font-family: &quot;Poppins&quot;, sans-serif;
                  font-size: 14px;
                  font-weight: 500;
                  color: black;
                  margin-top: 15px;
                  margin-bottom: 0;
                "
              >
                <span>
                  Penalidad parcial
                </span>
                <span *ngIf="penaltyRange.highestPenalty?.amountProf; else elseAmount">
                  (
                  {{ currencyAgency?.code }}
                  {{
                    penaltyRange.highestPenalty?.amountProf
                      | currencyConverterPure: cancellationPolicies?.currencyCancellation : currencyAgency.code : currencies
                      | number: "1.2-2"
                  }}
                  )
                </span>
                <ng-template #elseAmount>
                  <span *ngIf="penaltyRange.highestPenalty?.amount">
                    (
                    {{ currencyAgency?.code }}
                    {{
                      penaltyRange.highestPenalty?.amount
                        | currencyConverterPure: cancellationPolicies?.currencyCancellation : currencyAgency.code : currencies
                        | number: "1.2-2"
                    }}
                    )
                  </span>
                </ng-template>
              </p>
            </div>

            <div style="position: absolute; left: 0; top: 46%; z-index: 9999; height: 30px; background-color: black; width: 1px"></div>

            <div class="timeline-segment partial-segment" style="height: 12px; width: 100%"></div>

            <div style="position: absolute; right: 0; top: 46%; z-index: 9999; height: 30px; background-color: black; width: 1px"></div>

            <div class="d-flex justify-content-between px-2" style="width: 100%">
              <div class="d-flex flex-column">
                <p
                  class="mb-0 usb-rentacar-light-text"
                  style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black; margin-top: 20px"
                >
                  Del
                </p>
                <p class="mb-0 usb-rentacar-light-text" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black">
                  {{ penaltyRange.firstPolicy.from | date: "dd/MM/yyyy" }}
                </p>
              </div>
              <div class="d-flex flex-column">
                <p
                  class="mb-0 usb-rentacar-light-text"
                  style="text-align: right; font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black; margin-top: 20px"
                >
                  Hasta
                </p>
                <p class="mb-0 usb-rentacar-light-text" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black">
                  {{ penaltyRange.lastDate | date: "dd/MM/yyyy" }}
                </p>
              </div>
            </div>

            <p
              style="
                width: 100%;
                text-align: center;
                font-family: &quot;Poppins&quot;, sans-serif;
                font-size: 14px;
                font-weight: 500;
                color: #000000;
                border-left: 1.5px solid black;
                border-right: 1.5px solid black;
                margin-top: 35px;
              "
            >
              Reembolso parcial
            </p>
          </div>
        </ng-container>

        <div
          class="timeline-segment flex-column"
          *ngIf="isNoRefundActive()"
          [style.width.%]="getSegmentWidth(cancellationPolicies?.cancellationPolicies?.length + 1)"
        >
          <div class="d-flex flex-column align-items-center justify-content-start" style="width: 100%; height: 135px;">
            <img src="../../../../assets/icons/search-result/sin_reembolso.svg" style="width: 26px" alt="" />
            <p
              class="no-rembolsable"
              style="
                font-family: &quot;Poppins&quot;, sans-serif;
                font-size: 14px;
                font-weight: 500;
                color: black;
                margin-top: 15px;
                margin-bottom: 0;
              "
            >
              Sin reembolso
            </p>
          </div>

          <div
            class="timeline-segment no-refund-segment"
            [style.border-bottom-left-radius]="!isFreeCancellationActive() ? '6px' : '0'"
            [style.border-top-left-radius]="!isFreeCancellationActive() ? '6px' : '0'"
            style="height: 12px; border-bottom-right-radius: 6px; border-top-right-radius: 6px; width: 100%"
          ></div>

          <div *ngIf="isFreeCancellationActive()" class="d-flex justify-content-start pl-2" style="width: 100%">
            <div class="d-flex flex-column">
              <p
                class="mb-0 usb-rentacar-light-text"
                style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black; margin-top: 20px"
              >
                A partir del
              </p>
              <p class="mb-0 usb-rentacar-light-text" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black">
                {{ cancellationPolicies.arrivalDate | date: "dd/MM/yyyy" }}
              </p>
            </div>
          </div>

          <p
            *ngIf="isFreeCancellationActive()"
            style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 14px; font-weight: 500; color: #000000; margin-top: 35px"
          >
            Pérdida total
          </p>
        </div>
      </div>
    </div>

    <!-- Indicador HOY -->
    <div class="today-indicator" *ngIf="isFreeCancellationActive()" [style.left.%]="getTodayPosition()">
      <div class="d-flex flex-column p-1 align-items-center" style="background-color: black; border-radius: 6px; margin-bottom: 12px;
      position: relative;">
        <div style="
          position: absolute;
          top: 84%;
          left: 0;
          right: 0;
          margin: auto;
          width: 9px;
          height: 9px;
          background-color: #000000;
          rotate: 135deg;
          border-radius: 3px;
          z-index: -1;
        "></div>
        <div class="today-label">HOY</div>
        <div class="today-date" style="position: relative; z-index: 2">{{ today | date: "dd/MM/yyyy" }}</div>
      </div>
      <div class="today-dot"></div>
    </div>
  </div>

  <ng-template #noData>
    <p class="date mb-0">N/A</p>
  </ng-template>
</ng-container>

<ng-container>
  <div class="d-flex flex-column" *ngIf="cancellationPolicies.from !== 'N/A'">
    <div
      class="py-4 usb-cancellation-policies-dates"
      style="border-bottom: 0.5px solid #b3b3b3"
      *ngIf="isFreeCancellationActive()"
    >
      <div class="d-flex align-items-center mb-2">
        <div style="width: 40%">
          <div style="width: 120px; height: 10px; border-radius: 22px; background-color: #5cca90;"></div>
        </div>
        <div style="width: 60%">
          <p class="usb-modal-text--subtitle semi-bold mb-0">Cancelación gratuita</p>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <div class="d-flex flex-column" style="width: 40%">
          <p class="usb-modal-text--body mb-0">Hasta el</p>
          <p class="usb-modal-text--subtitle semi-bold mb-0">
            {{ adjustDate(cancellationPolicies.from, -1) | date: "dd/MM/yyyy" }}
          </p>
        </div>

        <div class="d-flex flex-column" style="width: 60%">
          <p class="usb-modal-text--body mb-0">Podras cancelar sin cargo</p>
        </div>
      </div>
    </div>

    <div
      *ngIf="getPartialPenaltyRange() as penaltyRange"
      class="d-flex align-items-center py-4 usb-cancellation-policies-dates"
      style="border-bottom: 0.5px solid #b3b3b3; gap: 0.5em"
    >
      <div class="d-flex flex-column" style="width: 100%">
        <div class="d-flex align-items-center mb-2" style="width: 100%">
          <div style="width: 40%">
            <div style="width: 120px; height: 10px; border-radius: 22px; background-color: #ffdc41;"></div>
          </div>
          <div style="width: 60%">
            <p class="usb-modal-text--subtitle semi-bold m-0">Cancelación con Penalidad Parcial</p>
          </div>
        </div>
        <!-- *ngFor="let policy of getActiveCancellationPolicies(); let i = index" -->

        <!-- <div class="d-flex justify-content-between px-2" style="width: 100%">
          <div class="d-flex flex-column">
            <p
              class="mb-0"
              style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black; margin-top: 20px"
            >
              Del
            </p>
            <p class="mb-0" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black">
              {{ policy.from | date: "dd/MM/yyyy" }}
            </p>
          </div>
          <div class="d-flex flex-column">
            <p
              class="mb-0"
              style="text-align: right; font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black; margin-top: 20px"
            >
              Hasta
            </p>
            <p class="mb-0" style="font-family: &quot;Poppins&quot;, sans-serif; font-size: 12px; font-weight: 500; color: black">
              {{ getNextDate(i) | date: "dd/MM/yyyy" }}
            </p>
          </div>
        </div> -->
        <div class="d-flex flex-column" style="width: 100%">
          <div class="d-flex align-items-center" style="width: 100%; margin-bottom: 20px">
            <div style="width: 40%">
              <p class="usb-modal-text--body m-0">Entre el</p>

              <p class="usb-modal-text--subtitle semi-bold m-0">
                {{ penaltyRange.firstPolicy.from | date: "dd/MM/yyyy" }}
                <span style="font-weight: 400;">hasta</span>
                {{ penaltyRange.lastDate | date: "dd/MM/yyyy" }}
              </p>

              <ng-container *ngIf="penaltyRange.highestPenalty?.fromTimeZoneAgency && penaltyRange.highestPenalty?.fromTime">
                <p class="mb-0 usb-modal-text--body" style="margin-bottom: 0.25em">Hora de la agencia</p>
                <p class="mb-2 usb-modal-text--subtitle semi-bold">
                  <span>{{ splitHour(penaltyRange.highestPenalty.fromTimeZoneAgency) }}</span>
                  {{ splitText(penaltyRange.highestPenalty.fromTimeZoneAgency) }}
                </p>

                <p class="mb-0 usb-modal-text--body" style="margin-bottom: 0.25em">Hora del proveedor</p>
                <p class="mb-0 usb-modal-text--subtitle semi-bold">
                  <span>{{ splitHour(penaltyRange.highestPenalty.fromTime) }}</span>
                  {{ splitText(penaltyRange.highestPenalty.fromTime) }}
                </p>
              </ng-container>
            </div>

            <div style="width: 60%">
              <p class="mb-0 usb-modal-text--body">
                <ng-container *ngIf="penaltyRange.highestPenalty?.amountProf">
                  Se aplicara una penalidad de
                  <span style="font-size: 14px !important; font-weight: 600"
                    >{{ currencyAgency?.code }}
                    {{
                      penaltyRange.highestPenalty?.amountProf
                        | currencyConverterPure: cancellationPolicies?.currencyCancellation : currencyAgency.code : currencies
                        | number: "1.2-2"
                    }}
                  </span>
                  del total de la reserva
                </ng-container>
                <ng-container *ngIf="!penaltyRange.highestPenalty?.amountProf">
                  Se aplicara una penalidad de
                  <span style="font-size: 14px !important; font-weight: 600"
                    >{{ currencyAgency?.code }}
                    {{
                      penaltyRange.highestPenalty?.amount
                        | currencyConverterPure: cancellationPolicies?.currencyCancellation : currencyAgency.code : currencies
                        | number: "1.2-2"
                    }}</span
                  >
                  del total de la reserva
                </ng-container>
              </p>
            </div>
          </div>
        </div>

        <div
          *ngIf="categoryId === 2 && cancellationPolicies?.cancellationPoliciesDescription"
          class="d-flex align-items-start"
          style="width: 100%"
        >
          <div style="width: 40%">
            <p class="text-generic" style="margin-bottom: 0.5em; font-size: 16px !important">Observaciones</p>
          </div>
          <div style="width: 60%">
            <p
              [innerHtml]="cancellationPolicies?.cancellationPoliciesDescription"
              class="mb-0 text-generic"
              style="font-weight: 400 !important; line-height: 1.2 !important"
            ></p>
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 usb-cancellation-policies-dates">
      <div class="d-flex align-items-center mb-2">
        <div style="width: 40%;">
          <div style="width: 120px; height: 10px; border-radius: 22px; background-color: #ed3c5b;"></div>
        </div>
        <div style="width: 60%;">
          <p class="mb-0 usb-modal-text--subtitle semi-bold">Sin Reembolso</p>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="d-flex flex-column" style="width: 40%">
          <p class="usb-modal-text--body mb-0">A partir del</p>
          <p class="usb-modal-text--subtitle semi-bold mb-0">
            {{ cancellationPolicies.arrivalDate | date: "dd/MM/yyyy" }}
          </p>
        </div>
        <div class="d-flex flex-column" style="width: 60%">
          <p class="mb-0 usb-modal-text--body">No se aceptarán cancelaciones ni reembolsos; también aplica en casos de no presentación.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column" *ngIf="cancellationPolicies.from === 'N/A'">
    <p class="date mb-0">N/A</p>
  </div>
</ng-container>

<!-- <ng-container *ngIf="cancellationPolicies.rateClass === 'NR'">
  <p class="date mb-0">100% costo</p>
</ng-container> -->
